import React, {Component} from 'react';
import Layout from '../components/layout';

class Error extends Component {
    render() {
        return (
            <Layout title="Error: Page does not exist!">
            </Layout>
        )
    }
}

export default Error;